import {
  KubernetesRegistryFormValues,
  KubernetesRegistryPolicyPayload,
  AllowedSourcePayload,
} from './types';

/**
 * Builds the API payload from form data
 * Converts form rows into per-registry access policies (namespaces only)
 */
export function buildKubernetesRegistryPayload(
  formData: KubernetesRegistryFormValues
): KubernetesRegistryPolicyPayload {
  const registryAccessPolicies = formData.accessRows.reduce<
    KubernetesRegistryPolicyPayload['RegistryAccessPolicies']
  >((policies, { registryId, namespaces }) => {
    const regIdStr = registryId.toString();

    const cleanedNamespaces = Array.from(
      new Set(
        (namespaces || []).map((ns) => ns.trim()).filter((ns) => ns !== '')
      )
    );

    return {
      ...policies,
      [regIdStr]: {
        Namespaces: cleanedNamespaces.map((namespace) => ({
          value: namespace,
          enforce: false,
        })),
      },
    };
  }, {});

  const allowedSources: AllowedSourcePayload[] = (
    formData.allowedSources || []
  ).map((source) => ({
    RegistryURLPrefix: source.registryUrlPrefix,
    Scope: source.scope,
    Namespaces:
      source.scope === 'namespaces'
        ? source.namespaces
            .map((ns) => ns.trim())
            .filter((ns) => ns !== '')
            .map((ns) => ({ value: ns, enforce: false }))
        : [],
  }));

  return {
    RegistryAccessPolicies: registryAccessPolicies,
    RestrictSources: formData.restrictSources,
    AllowedSources: allowedSources,
  };
}
